module.exports = __webpack_public_path__ + "img/pic2.60d478d6.png";